import React, { useState } from 'react';

const PasswordInputFieldWithToggle = props => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="rel">
            <input
                type={showPassword ? 'text' : 'password'}
                id={props.id}
                data-testid={props.id}
                required
                autoComplete="off"
                className={'text-field ' + (props.error ? 'error' : 'valid')}
                onChange={e => props.onPasswordChange(e.target.value)}
            />
            <span className={'eye-icon ' + (showPassword ? 'show' : 'hide')} onClick={() => setShowPassword(!showPassword)} />
        </div>
    );
};

export default PasswordInputFieldWithToggle;
